/* unplugin-vue-components disabled */import { render } from "./IndicatorRay.vue?vue&type=template&id=1c3c4fd5"
import script from "./IndicatorRay.vue?vue&type=script&lang=js"
export * from "./IndicatorRay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__